<p-multiSelect
  [options]="items"
  [(ngModel)]="selectedItems"
  appendTo="body"
  (onChange)="selectedItemsOnChange()"
  [formCtrlId]="formCtrlId"
  [formCtrl]="tipCtrl"
  (optionChanged)="handleOnItemChange($event)"
></p-multiSelect>
